export class UOM {
    unit: string
    description: string

    constructor(unit: string, description: string) {
        this.unit = unit
        this.description = description
    }
}